'use es6';

import KeyMirror from 'react-utils/keyMirror';
export const QUALITY_SCORES = KeyMirror({
  LOW: null,
  MEDIUM: null,
  HIGH: null
});
export const FORMATTED_RELEVANCE_SCORE = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High'
};
export const DEFAULT_KEYWORD_QUALITY_SCORE = 6;
export const extractQualityScoreWithDefault = qualityScore => {
  if (qualityScore === undefined) {
    return undefined;
  }

  if (typeof qualityScore !== 'number') {
    // Default keyword score for new keywords
    return DEFAULT_KEYWORD_QUALITY_SCORE;
  }

  return qualityScore;
};
export const keywordInAd = (ad, keyword) => {
  if (ad) {
    const adFields = ['headline', 'description1', 'description2', 'displayUrl'];
    return adFields.some(field => {
      if (ad[field]) {
        return ad[field].indexOf(keyword) > -1;
      } else {
        return false;
      }
    });
  }

  return false;
}; // input: keyword, ad object, count in LP, inTitle of LP
// output: LOW/MEDIUM/HIGH...undefined could change to number if we want finer granularity

export const getQualityScore = (keyword, ad, count, inTitle) => {
  if (count === undefined || inTitle === undefined) {
    return undefined;
  }

  if (count && (inTitle || keywordInAd(ad, keyword))) {
    return QUALITY_SCORES.HIGH;
  } else if (!count && !inTitle && !keywordInAd(ad, keyword)) {
    return QUALITY_SCORES.LOW;
  } else {
    return QUALITY_SCORES.MEDIUM;
  }
};